module.exports = __webpack_public_path__ + "static/media/img_8.9bc4e24f.png";